<script setup>
import { computed } from 'vue';
import { useI18n } from 'vue-i18n';

const props = defineProps({ name: { type: String, default: '' } });

const { t } = useI18n();
const label = computed(
  () => props.name.trim() || t('POST_SALE.COMMON.UNASSIGNED')
);
const initials = computed(() =>
  label.value
    .split(' ')
    .filter(Boolean)
    .slice(0, 2)
    .map(part => part[0]?.toUpperCase())
    .join('')
);
const avatarColor = computed(() => {
  let hash = 0;
  for (let index = 0; index < label.value.length; index += 1) {
    const shifted = new Int32Array([new Int32Array([hash])[0] * 32])[0];
    hash = label.value.charCodeAt(index) + shifted - hash;
  }
  return `hsl(${Math.abs(hash) % 360}, 70%, 80%)`;
});
</script>

<template>
  <div class="flex items-center gap-2">
    <span
      data-deed-person-avatar
      class="grid size-8 shrink-0 place-items-center rounded-full text-xs font-semibold text-lais-text"
      :style="{ backgroundColor: avatarColor }"
      :aria-label="label"
    >
      {{ initials }}
    </span>
    <span class="font-medium text-lais-text">{{ label }}</span>
  </div>
</template>
